module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/college-of-charleston-b697dcf8cf38c11677a00bb6cb65fbd4.svg";